(function ($) {

    $(document).ready(function () {
        $('.post-password-form').prev('.rt-reading-time').hide();
    });

    jQuery(document).ready(function () {

        // Adding click event listener to anchor links
        $(".section_making_sense_of_it_all a[href^='#']").on("click", function(event) {

            event.preventDefault();

            let target = $(this).attr("href");
            if(target !== "#"){
                let headerHeight = $("header").outerHeight();

                $("html, body").animate({
                    scrollTop: $(target).offset().top - headerHeight
                }, 800);
            }

        });

        if ($('.fly-in').length) {

            $('.fly-in .close').click(function () {
                $(this).closest('.fly-in').addClass('invisible').fadeOut('slow');
            });


            if ($('.contact-sales').length) {
                $('.fly-in').css('bottom', 130 + 'px');
            }

        }

        if (GetIEVersion() > 0) {
            $('body').addClass('msie');
        }


        /* owl-slider - top-slider homepage */
        $('.homepage-top-slider').addClass('owl-carousel').owlCarousel({
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            items: 1,
            //loop:true,
            //autoplay:true,
            autoplayTimeout: 5000,
            mouseDrag: false,
            touchDrag: false,
            nav: true,
            navText: ["", ""],
            dots: false,
            lazyLoad: true,
            activeClass: 'active'
        });


        /* brand-slider homepage */
        // $('.brand-slider-section-type-1').liMarquee();
        //
        // $(".brand-slider-section-type-1 .item img").hover(function () {
        //
        //     $(this).parent().addClass('show-hover');
        // }, function () {
        //     $(this).parent().removeClass('show-hover');
        // });


        /* add fa icons owl-slider nav */
        $('.owl-prev').addClass('fa fa-angle-left');
        $('.owl-next').addClass('fa fa-angle-right');

        /* mainmenu append <i> */
        $('.mainmenu > ul > li.menu-item-has-children').append('<i class="fa fa-angle-right"></i>');

        /* mainmenu add class prev li */
        $("header .top-2 .mainmenu > ul > li").hover(function () {
            $(this).prev('li').find('a').addClass('prev');
        }, function () {
            $(this).prev('li').find('a').removeClass('prev');
        });


        /* mainmenu: toggle mobile */
        $(".toggle-bttn").click(function () {
            $(".toggle-bttn").toggleClass("collapse");
            $("header .top-2 .mainmenu").toggleClass("collapse");
        });


        /* search-popup open */
        $(".search-bttn").click(function () {
            $(this).next().fadeIn(400);
        });
        $(".search-popup .close").click(function () {
            $(".search-popup").fadeOut(400);
        });


        /* scroll-top bttn */
        $('.scroll-top').click(function () {
            $('html, body').animate({scrollTop: 0}, 'slow');
        });


        /* collapse submenu mobile */
        $('.mainmenu>ul>li>i').click(function () {
            $(this).parent('li').toggleClass("collapse");
        });


        /* tabs toggle */
        /* owl-slider - tab-img-slider homepage */
        $(".tab-img-slider").addClass('owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            autoplay: true,
            autoplaySpeed: 500,
            nav: false,
            dots: false,
            autoplayTimeout: 3000
        });
        $(function () {
            var tabContainers = $('.tabs .tabs-content>div');
            tabContainers.addClass("passive").filter(':first').show();
            setTimeout(function () {
                tabContainers.removeClass("passive");
            }, 100);
            $('.tabs .tabs-ttl .ttl a').click(function () {
                tabContainers.hide().addClass("passive").removeClass('active');
                tabContainers.filter(this.hash).show().addClass('active');
                setTimeout(function () {
                    tabContainers.removeClass("passive");
                }, 100);
                $('.tabs .tabs-ttl .ttl a').removeClass('selected');
                $(this).addClass('selected');

                $('.tab-img-slider').css('display', 'none').trigger('prev.owl.carousel', [500]);
                $('.slider-' + $(this).parent().index()).css('display', 'block').trigger('next.owl.carousel', [500]);

                return false;
            }).filter(':first').click();
        });


        /* sort-block */
        // init Isotope
        var $grid = $('.sort-block .content').isotope({
            itemSelector: '.item',
            layoutMode: 'masonry'
        });

        // filter functions
        var filterFns = {
            // show if number is greater than 50
            numberGreaterThan50: function () {
                var number = $(this).find('.number').text();
                return parseInt(number, 10) > 50;
            },
            // show if name ends with -ium
            ium: function () {
                var name = $(this).find('.name').text();
                return name.match(/ium$/);
            }
        };
        // owl-slider - quotes
        var owl_quotes = $('.quotes').addClass('owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            autoplay: false,
            autoplayTimeout: 5000,
            mouseDrag: false,
            touchDrag: false,
            nav: false,
            dots: false,
            lazyLoad: true,
            activeClass: 'active'
        });
        // bind filter button click
        $('.sort-block .toggles ul').on('click', 'li', function () {
            var filterValue = $(this).attr('data-filter');
            // use filterFn if matches value
            filterValue = filterFns[filterValue] || filterValue;
            $grid.isotope({filter: filterValue});

            owl_quotes.trigger('to.owl.carousel', [$(this).index(), 300, true]);
        });
        // change is-checked class on buttons
        $('.sort-block .toggles ul').each(function (i, buttonGroup) {
            var $buttonGroup = $(buttonGroup);
            $buttonGroup.on('click', 'li', function () {
                $buttonGroup.find('.active').removeClass('active');
                $(this).addClass('active');
            });
        });
        // shuffle & display order of items
        $('.sort-block .toggles ul li:first-child').one("click", function () {
            //      shuffle
            $grid.isotope('shuffle');
            //get jQuery object of filtered items
            var $filteredItems = $($.map(iso.filteredItems, function (item) {
                return item.element;
            }));


            $filteredItems.each(function (i, elem) {
                $(elem).text(i);
            });
        });
        //$('.sort-block .toggles ul li:first-child').addClass('active');

        $('.section-isotope-grid-type-1 .sort-block .content .Video a.hover').click(function (e) {
            e.preventDefault();
            var _this = this;
            var $videoModal = $('.video-modal', $(this).parents('.item-wrapper'));

            $videoModal.addClass('shown');
        });

        /*$('.video-modal').live('click', function (e) {
            var $target = $(e.target);

            if ($target.hasClass('video-modal'))
                $(this).removeClass('shown');
            var iframe_src = $(this).find('iframe').attr('src');
            $(this).find('iframe').attr('src', iframe_src);
        });*/


// viewportChecker

        $('.isOnScreen').viewportChecker({
            classToAdd: 'visible'
        });

        $('.diag').viewportChecker({
            classToRemove: 'passive'
        });
        $('.benefits .wrapper .items .row .item').viewportChecker({
            classToAdd: 'animated lightSpeedIn'
        });
        $('.steps .columns .ttl span').viewportChecker({
            classToAdd: 'animated lightSpeedIn'
        });


        $('.parallax-text').viewportChecker({
            classToAdd: 'visible',
            repeat: true
        });


        /* toggle-switch */
        $('.switches .wpcf7-list-item label').click(function (e) {
            e.preventDefault();

            $(this).closest('.wpcf7-form-control').find('.wpcf7-list-item label input').each(function (i) {
                this.checked = false;
                $(this).parents('span').removeClass('active');
                //console.log(this);
            });
            $(this).find('input').get(0).checked = true;
            $(this).parent().addClass("active");
        });

        $('.customer .wpcf7-list-item.first').addClass("active");


        (function () {
            var hash = window.location.hash.toString();
            var index = parseInt(hash.substring(1));

            var item = $('.wpcf7-checkbox.toggle-switches > span').get(index - 1);

            if (item) {
                $('input', $(item)).get(0).click();
            }

            //alert(item);
        })();


        /* owl-slider - reviews-carousel */
        var owl_reviews_carousel = $('.reviews-carousel');
        owl_reviews_carousel.addClass('owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            autoplay: false,
            mouseDrag: false,
            touchDrag: false,
            nav: false,
            navText: ["", ""],
            dots: false,
            activeClass: 'active'
        });
        $(".reviews-block .wrapper .toggles > div:first-child").addClass('active');
        $(".reviews-block .wrapper .toggles > div img").click(function () {
            $(".reviews-block .wrapper .toggles > div").removeClass('active');
            $(this).parent().addClass('active');
            owl_reviews_carousel.trigger('to.owl.carousel', [$(this).parent().index(), 300, true]);
        });


        $(".add-on-features .item:nth-child(odd)").addClass('left');
        $(".add-on-features .item:nth-child(even)").addClass('right');


        /* Section grid type 3 - tab blue items */
        var button = $('.blue_hover_group .toggle-buttons>.toggle-button');
        var blue_hover = $('.blue_hover_group .content>.blue-hovers');

        $('.blue_hover_group .toggle-buttons>.toggle-button:first-child').addClass('active');
        $('.blue_hover_group .content>.blue-hovers:first-child').css('display', 'block');

        button.click(function () {
            button.removeClass('active');
            $(this).addClass('active');
            var snum = $(this).attr('data-snum');

            blue_hover.each(function () {
                if (($(this).attr('data-snum')) == snum) {
                    $(this).fadeIn('slow');
                } else {
                    $(this).css('display', 'none');
                }
            });
        });


        $('.what-our-client-say .slider').addClass('owl-carousel').owlCarousel({
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            items: 1,
            //loop:true,
            //autoplay:true,
            autoplayTimeout: 5000,
            mouseDrag: false,
            touchDrag: false,
            nav: false,
            dots: true,
            lazyLoad: true,
            activeClass: 'active'
        });


    });

    $(window).on("load", function () {
        $('body').addClass("loaded");
        $('.sort-block .toggles ul li:first-child').click();
        if ($(".popup").length > 0) {
            $(".popup .close").on('click', function (event) {
                event.preventDefault();
                $(".popup").fadeOut('slow');
            });
            $(".popup .close-btn").click(function (event) {
                event.preventDefault();
                $(".popup").fadeOut('slow');
            });

            setTimeout(function () {
                $(".popup").fadeIn('slow');

                hj('trigger', 'popup_heatmap');
                console.log('show popup');
            }, 3000);
        }
        $(document).keyup(function (e) {
            if (e.keyCode == 27) {
                $(".popup").fadeOut('slow');
            }
        });


        if (window.location.hash == '#onyx-calc') {
            console.log('onyx-calc');
            $('html, body').animate({
                scrollTop: $("#onyx-calc").offset().top - 60
            }, 1000);
        }


    });

    /* mainmenu: toggle fixed on scroll */
    var $header = $("header");
    $(window).on("scroll", function () {
        if ($(window).width() > 600) {
            if ($(window).scrollTop() > 50 && $header.hasClass("default")) {
                $header.removeClass("default").addClass("fixed");
            } else if ($(window).scrollTop() <= 50 && $header.hasClass("fixed")) {
                $header.removeClass("fixed").addClass("default");
            }
        } else {
            $header.removeClass("default").addClass("fixed");
        }
    });

    let interval, changeInterval, body = $("body"), target = $(".section-contacts-page"),
        fakeBtn = target.find(".help-button");

    interval = setInterval(function () {
        if ($(".embeddedServiceHelpButton").length > 0) {
            clearInterval(interval)
            fakeBtn.addClass("visible")
        }
    }, 500)

    function handleChange() {
        changeInterval = setInterval(function () {
            if ($(".embeddedServiceSidebar").length > 0) {
                clearInterval(changeInterval)
                fakeBtn.find(".main").show()
                fakeBtn.find(".loading").hide()
            }
        }, 500)
    }

    if (target.length) {
        const fakeBtn = target.find(".help-button")

        fakeBtn.on("click", () => {
            body.find(".helpButton .uiButton").trigger("click")

            fakeBtn.find(".main").hide()
            fakeBtn.find(".loading").show()
            handleChange()
        })
        target.parent("body").addClass("need-assistance");
    }

    /* owl-slider - parallax-slider careers */
    $('.parallax-slider').addClass('owl-carousel').owlCarousel({
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        mouseDrag: false,
        touchDrag: false,
        nav: false,
        navText: ["", ""],
        dots: false,
        lazyLoad: true,
        activeClass: 'active'
    });

    /* owl-slider - Set Equal Height */
    $(window).on("load resize", function () {
        $(".set-equal-height").css("height", "auto");
        //setTimeout(function() {
        var mainDivs = $(".set-equal-height");
        var greyBlocks = $(".get-equal-height");
        var maxHeight = 0;
        for (var i = 0; i < greyBlocks.length; ++i) {
            if (maxHeight < $(greyBlocks[i]).outerHeight()) {
                maxHeight = $(greyBlocks[i]).outerHeight();
            }
        }
        for (var i = 0; i < mainDivs.length; ++i) {
            $(mainDivs[i]).outerHeight(maxHeight);
        }
    });


    $(window).on("scroll load", function () {
        if ($('.fly-in').length) {
            $('.fly-in').removeClass('invisible');
        }
    });

    $(window).on("load", function () {

        if ($('.contact-sales').length) {

            $('.contact-sales').removeClass('invisible');

            setInterval(function () {
                $('.contact-sales').addClass('shake');
                setTimeout(function () {
                    $('.contact-sales').removeClass('shake');
                }, 1000);
            }, 15000);

        }

    });

    $('.parallax-window .learn-more').on('click', function (e) {
        var dest = $(this).closest('.parallax-window').next('div').offset();

        //console.log(dest);

        $('html, body').animate({scrollTop: dest.top - 62}, 'slow');
    });


    $(document).ready(function () {

        if ($.cookie("cookie-pop-up") != 'false') {
            $.cookie("cookie-pop-up", 'true', {expires: 365, path: '/'});
        } else {
            $(".cookie-pop-up").hide();
        }

        $(".cookie-pop-up-close").on("click", function () {
            $.cookie("cookie-pop-up", 'false', {expires: 365, path: '/'});
            $(".cookie-pop-up").fadeOut('slow');
        });

        //console.log($.cookie("cookie-pop-up"));

    });


    $(document).ready(function () {
        //$('.section-tag-cloud ul li div').parallaxContent();
        $('.parallax-background').parallaxBackground();
    });


    $(document).ready(function () {
        if ($('.section_making_sense_of_it_all').length) {
            $('.section_making_sense_of_it_all .items .items-list .item').viewportChecker({
                classToAdd: 'active',
                callbackFunction: function (elem) {
                    var span = elem.find('.item-value>span');
                    span.prop('Counter', 0).animate({
                        Counter: span.text()
                    }, {
                        duration: 3000,
                        easing: 'swing',
                        step: function (now) {
                            if (span.text().indexOf(".") == -1) {
                                span.text(Math.ceil(now));
                            } else {
                                span.text(this.Counter.toFixed(1));
                            }

                        }
                    });
                }
            });
        }

    });


    $(window).on('scroll', function () {
        if ($('.parallax-text').hasClass('visible')) {

            var offset = $('.parallax-text').offset();
            var scrollTop = $(window).scrollTop();
            var value = (offset.top - scrollTop) * 2;
            $('.parallax-text').css('right', 'calc(50% - ' + value + 'px)');
        }

    });

    $(document).ready(function () {
        $('.bttn').on('click', function (e) {
            var href = $(this).attr('href');

            if (href.match("^goto:")) {
                e.preventDefault();
                var goto = $(href.split('goto:')[1]).offset().top;
                $('html, body').animate({scrollTop: goto - 62}, 'slow');
            }
        });


        $('.wsp-pages-list a').each(function () {
            $(this).text($(this).text().toLowerCase());
        });

    });


    $(window).on("resize load", function () {
        if ($('body').outerHeight() < $(window).height()) {
            var height = $(window).height() - $('footer').outerHeight();
            setTimeout(function () {
                $('.main-page-wrap').css('min-height', height + 'px');
            }, 300);

        } else {
            $('.main-page-wrap').removeAttr('style');
        }
    });

    if ($('.section_onyx_payments_capabilities').length > 0) {

        function rorate_around(container, svg, speed, delay, revers) {
            var rotation1;
            var rotation2;
            if (revers == true) {
                rotation1 = -360;
                rotation2 = 360;
            } else {
                rotation1 = 360;
                rotation2 = -360;
            }
            TweenMax.to(container, speed, {
                transformOrigin: "35% 40%",
                rotation: rotation1,
                ease: Linear.easeNone,
                repeat: -1,
                delay: delay
            });

            TweenMax.to(svg, speed, {
                transformOrigin: "50% 50%",
                rotation: rotation2,
                ease: Linear.easeNone,
                repeat: -1,
                delay: delay
            });
        }

        rorate_around($('.section_onyx_payments_capabilities .svg-in-1'), $('.section_onyx_payments_capabilities .svg-in-1 svg'), 15, 0, true);
        rorate_around($('.section_onyx_payments_capabilities .svg-in-2'), $('.section_onyx_payments_capabilities .svg-in-2 svg'), 10, 1, false);
        rorate_around($('.section_onyx_payments_capabilities .svg-in-3'), $('.section_onyx_payments_capabilities .svg-in-3 svg'), 18, 1.2, true);
        rorate_around($('.section_onyx_payments_capabilities .svg-in-4'), $('.section_onyx_payments_capabilities .svg-in-4 svg'), 16, 1.5, false);
        rorate_around($('.section_onyx_payments_capabilities .svg-in-5'), $('.section_onyx_payments_capabilities .svg-in-5 svg'), 11, 0.5, true);


    }


})(jQuery);


function GetIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0)
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

    // If IE 11 then look for Updated user agent string.
    else if (!!navigator.userAgent.match(/Trident\/7\./))
        return 11;

    else
        return 0; //It is not IE
}


// WEBPACK FOOTER //
// ./src/js/custom/script.js